import type { JSX } from 'react';

import {
	useDecisionMakerResponsePageData,
	useDecisionMakerResponsePageState,
} from 'src/app/pages/decisionMakerResponse/details/pageContext';
import { useSocialProofLabel } from 'src/app/shared/hooks/socialProof';

type Result = ModelHookResult<{
	hiddenOnMobile: boolean;
	socialProofLabel: string | JSX.Element | JSX.Element[];
}>;

export function useActionButton(): Result {
	const [{ beforeSuggestedPetitions }] = useDecisionMakerResponsePageState();
	const {
		data: {
			petitionCreatedLessThanADayAgo,
			decisionMakerResponse: {
				petition: {
					dailySignatureCount,
					dailySignatureCountLocalized,
					weeklySignatureCount,
					weeklySignatureCountLocalized,
				},
			},
		},
	} = useDecisionMakerResponsePageData();
	const socialProofLabel = useSocialProofLabel({
		dailySignatureCount,
		dailySignatureCountLocalized,
		weeklySignatureCount,
		weeklySignatureCountLocalized,
		createdLessThanOneDayAgo: petitionCreatedLessThanADayAgo,
	});

	return {
		data: {
			hiddenOnMobile: !beforeSuggestedPetitions,
			socialProofLabel,
		},
	};
}
